import { Pagination } from '@/services/models/common-model'
import {
  MarketplaceFilters,
  OrderEntity
} from '@/services/models/marketplace-service-model'

export interface MarketplaceState {
  marketplaceOrders: Array<OrderEntity>
  pagination: Pagination
  filters: MarketplaceFilters
  lastRefreshed: string
  updatedSinceLastRefresh: Array<number>
  updates: Array<number>
  nextLoadSuggestions: Array<OrderEntity>
}

export enum OrderDetailAction {
  AcceptNow = 'AcceptNow',
  PlaceRequest = 'PlaceRequest'
}

export enum SortingOption {
  Newest = 'newest',
  Oldest = 'oldest',
  Relevance = 'relevance'
}
export interface RadiusOption {
  key: string
  value: number
}
